import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-10 md:py-16 bg-white" data-id="element-114">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-116">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-5" data-id="element-117">
            Travel isn't a vacation when you're a parent...
          </h2>

          <div className="space-y-4 text-base md:text-lg text-gray-600 leading-relaxed text-left" data-id="element-118">
            <p data-id="element-119">
              It's an "away game" played in a high-stress environment. Most
              "travel tips" tell you to "just relax" or "bring a tablet."
            </p>
            <p data-id="element-120">
              But tablets die. WiFi fails. And "relaxing" is impossible when
              your two-year-old is trying to kick the seat in front of them for
              the fourth hour in a row.
            </p>

            <div className="mt-6 p-5 bg-brand-lightBlue rounded-2xl border border-brand-blue/20 shadow-sm" data-id="element-121">
              <p className="text-lg md:text-xl font-bold text-brand-blue text-center leading-snug" data-id="element-122">
                The real problem isn't your child—it's a lack of a structured
                sensory system designed for a 17-inch tray table. 🧸
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}